/* src/app/workshop/pages/parts/parts.component.scss */
/*# sourceMappingURL=parts.component.css.map */
